import React from 'react'
import {
  Nav, NavLink, NavbarContainer, Span, NavLogo, NavItems, GitHubButton, ButtonContainer, MobileIcon, MobileMenu, LinkedinButton,
  MobileLink
} from './NavbarStyledComponent'
// import { DiCssdeck } from 'react-icons/di';
import { Bio } from '../../data/constants';
import { FaBars, FaTimes } from 'react-icons/fa';
import { MdLightMode } from "react-icons/md";
import { useTheme } from 'styled-components';
import styled from "styled-components";

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faMoon } from '@fortawesome/free-solid-svg-icons';

const ToggleButton = styled.button`

  background-color: white;
  // padding: 14px; /* Adjust padding as needed */
  border-radius: 50%;
  height: 32px; 
  width: 40px;
  color: ${({ theme }) => theme.text};
  border: none; 
  cursor: pointer;
  font-size: 16px;
  margin-right: 20px; /* Adjust the margin as needed */
  position: relative;
  overflow: hidden;
  padding:20px;

  &:before {
    content: '';
    position: absolute;
    width: 100%;
    height: 100%;
    background-color: ${({ theme }) => theme.primary};
    border-radius: inherit;
    left: ${({ darkMode }) => (darkMode ? '0%' : '100%')};
    transition: left 0.3s ease-in-out;
  }

  svg {
    // padding:14px;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    z-index: 2;
    height: 36px; /* Adjust the height as needed */
    width: 36px; /* Adjust the width as needed */
    // padding: 8px; /* Adjust padding as needed */
  }
`;


const Navbar = ({ setDarkMode, darkMode }) => {
  const [isOpen, setIsOpen] = React.useState(false);
  const theme = useTheme()
  const themeChange = () => {
    setDarkMode((prevDarkMode) => !prevDarkMode);
  };
  return (
    <Nav>
      <NavbarContainer>
        <ToggleButton onClick={themeChange}>
          {darkMode ? <MdLightMode /> :
            <FontAwesomeIcon icon={faMoon} />}
        </ToggleButton>
        <NavLogo to='/'>
          <Span style={{ display: "flex", alignItems: "center", color: "white", marginBottom: '20;', cursor: 'pointer' }}>
            Champa Lal Suthar
          </Span>
        </NavLogo>
        <MobileIcon>
          {isOpen ? (
            <FaTimes onClick={() => setIsOpen(!isOpen)} />
          ) : (
            <FaBars onClick={() => setIsOpen(!isOpen)} />
          )}
        </MobileIcon>
        <NavItems>
          <NavLink href="#about">About</NavLink>
          <NavLink href='#skills'>Skills</NavLink>
          <NavLink href='#experience'>Experience</NavLink>
          <NavLink href='#projects'>Projects</NavLink>
          <NavLink href='#education'>Education</NavLink>
          <NavLink target="Blank" href='https://blog.champalalsuthar.dev/home'>Blogs</NavLink>
        </NavItems>
        <ButtonContainer>
          <GitHubButton href={Bio.github} target="_blank">Github</GitHubButton>
          <LinkedinButton href={Bio.linkedin} target="_blank">Linkedin</LinkedinButton>
        </ButtonContainer>
        {
          isOpen &&
          <MobileMenu isOpen={isOpen}>
            <MobileLink href="#about" onClick={() => {
              setIsOpen(!isOpen)
            }}>About</MobileLink>
            <MobileLink href='#skills' onClick={() => {
              setIsOpen(!isOpen)
            }}>Skills</MobileLink>
            <MobileLink href='#experience' onClick={() => {
              setIsOpen(!isOpen)
            }}>Experience</MobileLink>
            <MobileLink href='#projects' onClick={() => {
              setIsOpen(!isOpen)
            }}>Projects</MobileLink>
            <MobileLink href='#education' onClick={() => {
              setIsOpen(!isOpen)
            }}>Education</MobileLink>
            <MobileLink target="Blank" href='https://blog.champalalsuthar.dev/home' onClick={() => {
              setIsOpen(!isOpen)
            }}>Blogs</MobileLink>
            <GitHubButton style={{ padding: '10px 16px', background: `${theme.primary}`, color: 'white', width: 'max-content' }} href={Bio.github} target="_blank">Github</GitHubButton>
            <LinkedinButton style={{ padding: '10px 16px', background: `${theme.primary}`, color: 'white', width: 'max-content' }} href={Bio.linkedin} target="_blank">Linkedin</LinkedinButton>
          </MobileMenu>
        }
      </NavbarContainer>
    </Nav>
  )
}

export default Navbar